import BodyType from 'owa-service/lib/contract/BodyType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getRandomBetween } from 'mini-common-utils/lib/utils/getRandomNumberBetween';
import { ImageProxyCapability } from 'mini-inline-image-loader/lib/schema/ImageProxyCapability';
import { isImageProxyEnabled } from 'mini-inline-image-loader/lib/utils/isImageProxyEnabled';
import {
    INLINE_IMAGE_CUSTOM_DATA_TEMPLATE,
    INLINE_IMAGE_URL_TEMPLATE,
} from 'owa-inline-image-constants/lib/InlineImageServiceConstant';

export const cssScopeClassName = 'rps_' + getRandomBetween(1, 0xffff).toString(16);
export const maximumBodySize = 2 * 1024 * 1024;
export const maximumRecipientsToReturn = 20;
export const inlineImageUrlOnLoadTemplate = 'InlineImageLoader.GetLoader().Load(this)';

const getBlockContentFromUnknownSenders = () =>
    !!getUserConfiguration()?.SafetyUserOptions?.BlockContentFromUnknownSenders;

export const getComposeItemResponseShape = (bodyType: BodyType) =>
    itemResponseShape({
        BaseShape: 'IdOnly',
        ClientSupportsIrm: true,
        FilterHtmlContent: false,
        BodyType: bodyType,
        InlineImageCustomDataTemplate: INLINE_IMAGE_CUSTOM_DATA_TEMPLATE,
        InlineImageUrlTemplate: INLINE_IMAGE_URL_TEMPLATE,
        AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
    });

export const getBaseItemResponseShape = (): ItemResponseShape => {
    const baseItemResponseShape: ItemResponseShape = {
        BaseShape: 'IdOnly',
        AddBlankTargetToLinks: true,
        BlockContentFromUnknownSenders: getBlockContentFromUnknownSenders(),
        BlockExternalImagesIfSenderUntrusted: true,
        ClientSupportsIrm: true,
        CssScopeClassName: cssScopeClassName,
        FilterHtmlContent: true,
        FilterInlineSafetyTips: true,
        ImageProxyCapability: isImageProxyEnabled()
            ? ImageProxyCapability.OwaAndConnectorsProxy
            : ImageProxyCapability.None,
        InlineImageCustomDataTemplate: INLINE_IMAGE_CUSTOM_DATA_TEMPLATE,
        InlineImageUrlTemplate: INLINE_IMAGE_URL_TEMPLATE,
        MaximumBodySize: maximumBodySize,
        MaximumRecipientsToReturn: maximumRecipientsToReturn,
        AdditionalProperties: [],
    };

    // Bug 42744: fwk-enforceCsp disable inline code which also disables inline image load
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/42744
    // To workaround CSP disabling inline code, we will use a InlineImageHandler (a content handler) that runs
    // after content is loaded in reading pane
    baseItemResponseShape.InlineImageUrlOnLoadTemplate = '';

    return itemResponseShape(baseItemResponseShape);
};
